/* BMI design-system behaviour (ca-* sections). No dependencies. Every form still works without JS:
   add-to-bag forms post to /cart/add and Shopify redirects to the cart. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const money = (cents) => {
    const v = cents / 100;
    return '$' + (Number.isInteger(v) ? v : v.toFixed(2));
  };

  const setBagCount = (n) => document.querySelectorAll('[data-ca-bag-count]').forEach((el) => { el.textContent = n; });
  const refreshBag = () => fetch(root + 'cart.js').then((r) => r.json()).then((c) => setBagCount(c.item_count)).catch(() => {});

  const addItems = async (items) => {
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) throw new Error((await res.json()).description || 'Could not add to bag');
    await refreshBag();
  };

  const flash = (btn, label) => {
    const target = btn.querySelector('[data-ca-label]') || btn;
    const was = target.dataset.caWas || target.textContent;
    target.dataset.caWas = was;
    target.textContent = label;
    setTimeout(() => { target.textContent = was; }, 2200);
  };

  // Add-to-bag forms (cards, PDP, routine builder)
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ca-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const items = [];
    const id = form.querySelector('[name="id"]')?.value;
    const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);
    const plan = form.querySelector('[name="selling_plan"]:checked')?.value;
    if (id) items.push(plan ? { id: Number(id), quantity: qty, selling_plan: Number(plan) } : { id: Number(id), quantity: qty });
    form.querySelectorAll('[data-ca-extra]:checked, input[type="hidden"][data-ca-item]:not(:disabled)').forEach((el) => {
      items.push({ id: Number(el.value), quantity: 1 });
    });
    if (!items.length) return;
    btn?.setAttribute('disabled', '');
    try {
      await addItems(items);
      flash(btn, 'Added');
    } catch (err) {
      flash(btn, 'Try again');
      console.error(err);
    } finally {
      btn?.removeAttribute('disabled');
    }
  });

  // Cover carousel (image band with slides): crossfade on a timer; pauses on hover/focus and when
  // off screen; no autoplay with reduced motion.
  document.querySelectorAll('[data-ca-carousel]').forEach((el) => {
    const slides = [...el.querySelectorAll('[data-ca-slide]')];
    const dots = [...el.querySelectorAll('[data-ca-dot]')];
    const wait = Number(el.dataset.interval) || 6000;
    const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let i = 0;
    let timer = null;
    let seen = false;
    let held = false;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => { s.classList.toggle('is-on', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach((d, k) => d.toggleAttribute('aria-current', k === i));
    };
    const stop = () => { clearInterval(timer); timer = null; };
    const play = () => { stop(); if (!still && seen && !held) timer = setInterval(() => show(i + 1), wait); };
    el.querySelector('[data-ca-prev]')?.addEventListener('click', () => { show(i - 1); play(); });
    el.querySelector('[data-ca-next]')?.addEventListener('click', () => { show(i + 1); play(); });
    dots.forEach((d) => d.addEventListener('click', () => { show(Number(d.dataset.caDot)); play(); }));
    ['mouseenter', 'focusin'].forEach((t) => el.addEventListener(t, () => { held = true; stop(); }));
    ['mouseleave', 'focusout'].forEach((t) => el.addEventListener(t, () => { held = false; play(); }));
    new IntersectionObserver(([e]) => { seen = e.isIntersecting; play(); }, { threshold: 0.3 }).observe(el);
  });

  // Slider (image band, layout "slider"): slides one photo to the left on a timer and loops by
  // sliding onto a copy of the first photo, then snapping back. No controls; still with reduced motion.
  document.querySelectorAll('[data-ca-slider]').forEach((el) => {
    const track = el.querySelector('.ca-slider__track');
    const n = track.children.length;
    if (n < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const copy = track.children[0].cloneNode(true);
    copy.alt = '';
    copy.setAttribute('aria-hidden', 'true');
    track.appendChild(copy);
    const wait = Number(el.dataset.interval) || 6000;
    let i = 0;
    let seen = false;
    track.addEventListener('transitionend', () => {
      if (i !== n) return;
      track.style.transition = 'none';
      i = 0;
      track.style.transform = 'translateX(0)';
    });
    setInterval(() => {
      if (!seen || document.hidden) return;
      i += 1;
      track.style.transition = 'transform 1100ms cubic-bezier(0.65, 0, 0.35, 1)';
      track.style.transform = `translateX(-${i * 100}%)`;
    }, wait);
    new IntersectionObserver(([e]) => {
      seen = e.isIntersecting;
      // Photos sit off to the side, so lazy loading would leave them blank: load them all once the slider is near.
      if (seen) track.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
    }, { rootMargin: '400px 0px' }).observe(el);
  });

  // Subscribe and save: the button price follows the chosen delivery frequency
  document.addEventListener('change', (e) => {
    const r = e.target.closest('[data-ca-subs] input[name="selling_plan"]');
    const out = r?.closest('form')?.querySelector('[data-ca-sub-price]');
    if (out && r.dataset.price) out.textContent = money(Number(r.dataset.price));
  });

  // Tabs: filter a grid by data-tabs on each card
  document.querySelectorAll('[data-ca-tabs]').forEach((wrap) => {
    const title = wrap.querySelector('[data-ca-tab-title]');
    const cards = wrap.querySelectorAll('[data-ca-card]');
    const limit = (key) => (key === 'all' ? 12 : 4);
    const show = (key, label) => {
      wrap.querySelectorAll('[data-ca-tab]').forEach((t) => t.setAttribute('aria-selected', String(t.dataset.caTab === key)));
      let n = 0;
      cards.forEach((c) => {
        const match = (c.dataset.tabs || '').split(' ').includes(key);
        const on = match && n < limit(key);
        if (on) n += 1;
        c.hidden = !on;
      });
      if (title) title.textContent = label;
    };
    wrap.querySelectorAll('[data-ca-tab]').forEach((t) => t.addEventListener('click', () => show(t.dataset.caTab, t.dataset.title || t.textContent)));
    const first = wrap.querySelector('[data-ca-tab]');
    if (first) show(first.dataset.caTab, first.dataset.title || first.textContent);
  });

  // Ingredient explorer: one chip -> one image + one panel
  document.querySelectorAll('[data-ca-explorer]').forEach((wrap) => {
    const pick = (key) => {
      wrap.querySelectorAll('[data-ca-ing]').forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.caIng === key)));
      wrap.querySelectorAll('[data-ca-ing-img]').forEach((i) => i.classList.toggle('is-on', i.dataset.caIngImg === key));
      wrap.querySelectorAll('[data-ca-ing-panel]').forEach((p) => { p.hidden = p.dataset.caIngPanel !== key; });
    };
    wrap.querySelectorAll('[data-ca-ing]').forEach((c) => c.addEventListener('click', () => pick(c.dataset.caIng)));
    const first = wrap.querySelector('[data-ca-ing]');
    if (first) pick(first.dataset.caIng);
  });

  // Routine builder: two answers -> one of the preset routines
  document.querySelectorAll('[data-ca-routine]').forEach((wrap) => {
    const state = {};
    const update = () => {
      const key = (state.feel || '') + '-' + (state.when || '');
      let total = 0;
      wrap.querySelectorAll('[data-ca-routine-set]').forEach((set) => {
        const on = set.dataset.caRoutineSet === key;
        set.hidden = !on;
        set.querySelectorAll('input[data-ca-item]').forEach((i) => { i.disabled = !on; });
        if (on) total = Number(set.dataset.total || 0);
      });
      wrap.querySelectorAll('[data-ca-routine-total]').forEach((el) => { el.textContent = money(total); });
      const ship = wrap.querySelector('[data-ca-routine-ship]');
      if (ship) ship.hidden = total < (window.caFreeShip || 0);
    };
    wrap.querySelectorAll('[data-ca-q]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const q = btn.dataset.caQ;
        state[q] = btn.dataset.value;
        wrap.querySelectorAll(`[data-ca-q="${q}"]`).forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
        update();
      });
      if (btn.getAttribute('aria-pressed') === 'true') state[btn.dataset.caQ] = btn.dataset.value;
    });
    update();
  });

  // Product page
  document.querySelectorAll('[data-ca-pdp]').forEach((pdp) => {
    // Gallery: thumbnails switch the main image; arrows step through; a size with its own photo shows it
    const thumbs = [...pdp.querySelectorAll('[data-ca-thumb]')];
    const showMedia = (id) => {
      if (!pdp.querySelector(`.ca-stage [data-ca-media="${id}"]`)) return;
      thumbs.forEach((t) => t.setAttribute('aria-current', String(t.dataset.caThumb === id)));
      pdp.querySelectorAll('.ca-stage [data-ca-media]').forEach((m) => {
        const on = m.dataset.caMedia === id;
        m.classList.toggle('is-on', on);
        if (m.tagName === 'VIDEO') { if (on) m.play().catch(() => {}); else m.pause(); }
      });
      pdp.querySelector(`[data-ca-thumb="${id}"]`)?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    };
    thumbs.forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.caThumb)));
    pdp.querySelectorAll('[data-ca-step]').forEach((b) => b.addEventListener('click', () => {
      const i = thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true');
      const next = thumbs[(i + Number(b.dataset.caStep) + thumbs.length) % thumbs.length];
      if (next) showMedia(next.dataset.caThumb);
    }));

    const variants = JSON.parse(pdp.querySelector('[data-ca-variants]')?.textContent || '[]');
    const idInput = pdp.querySelector('form[data-ca-add] [name="id"]');
    const qtyInput = pdp.querySelector('[name="quantity"]');
    const priceEls = pdp.querySelectorAll('[data-ca-price]');
    const submit = pdp.querySelector('form[data-ca-add] [type="submit"]');
    const stickyBtn = document.querySelector('[data-ca-sticky-add]');
    const pairing = pdp.querySelector('[data-ca-extra]');
    const ship = pdp.querySelector('[data-ca-ship]');
    let current = variants.find((v) => String(v.id) === idInput?.value) || variants[0];

    const updateTotals = () => {
      if (!current) return;
      const qty = Math.max(1, parseInt(qtyInput?.value || '1', 10));
      const extra = pairing?.checked ? Number(pairing.dataset.price || 0) : 0;
      const sub = current.price * qty + extra;
      priceEls.forEach((el) => { el.textContent = money(current.price); });
      const label = submit?.querySelector('[data-ca-label]');
      if (label) label.textContent = current.available ? 'Add to bag · ' + money(sub) : 'Sold out';
      if (submit) submit.disabled = !current.available;
      if (ship) {
        const need = window.caFreeShip || 0;
        const pct = need ? Math.min(100, Math.round((sub / need) * 100)) : 100;
        ship.querySelector('[data-ca-ship-bar]').style.width = pct + '%';
        ship.querySelector('[data-ca-ship-left]').textContent = sub >= need ? 'This order ships free.' : money(need - sub) + ' away from free shipping';
        ship.querySelector('[data-ca-ship-right]').textContent = sub >= need ? 'Free shipping' : money(sub) + ' of ' + money(need);
      }
    };

    pdp.querySelectorAll('input[name="ca-variant"]').forEach((r) => r.addEventListener('change', () => {
      current = variants.find((v) => String(v.id) === r.value);
      if (idInput && current) idInput.value = current.id;
      if (current?.media) showMedia(String(current.media));
      const url = new URL(window.location.href);
      url.searchParams.set('variant', r.value);
      window.history.replaceState({}, '', url);
      updateTotals();
    }));
    pdp.querySelectorAll('[data-ca-qty]').forEach((b) => b.addEventListener('click', () => {
      const n = Math.max(1, parseInt(qtyInput.value || '1', 10) + Number(b.dataset.caQty));
      qtyInput.value = n;
      updateTotals();
    }));
    qtyInput?.addEventListener('change', updateTotals);
    pairing?.addEventListener('change', updateTotals);
    updateTotals();

    // Sticky bar appears once the buy button scrolls out of view
    const bar = document.querySelector('[data-ca-pdpsticky]');
    if (bar && submit && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => bar.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(submit);
    }
    stickyBtn?.addEventListener('click', () => submit?.click());
  });

  // Menu drawer
  document.querySelectorAll('[data-ca-drawer-open]').forEach((b) => b.addEventListener('click', () => {
    const d = document.getElementById(b.dataset.caDrawerOpen);
    d?.classList.add('is-open');
    b.setAttribute('aria-expanded', 'true');
    d?.querySelector('a, button')?.focus();
  }));
  document.querySelectorAll('[data-ca-drawer-close]').forEach((b) => b.addEventListener('click', () => {
    const d = b.closest('.ca-drawer');
    d?.classList.remove('is-open');
    document.querySelector(`[data-ca-drawer-open="${d?.id}"]`)?.setAttribute('aria-expanded', 'false');
  }));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') document.querySelectorAll('.ca-drawer.is-open [data-ca-drawer-close]').forEach((b) => b.click());
  });
})();
